import { usePartnerConfig } from '../../contexts/partnerConfig';

interface RequiredPolicyHiddenInputsProps {
  name: string;
}

export function RequiredPolicyHiddenInputs({
  name
}: RequiredPolicyHiddenInputsProps) {
  const { config } = usePartnerConfig();

  const requiredPolicies = config?.myAccount?.requiredPolicies;

  return requiredPolicies?.map(({ key }) => (
    <input
      type="hidden"
      name={name}
      value={key}
      data-testid={`hidden-input-${key}`}
      key={key}
    />
  ));
}
